import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoArrendamientosComponent } from './info-arrendamientos/info-arrendamientos.component';
import { TimeLineComponent } from './time-line/time-line.component';
import { LoadingComponent } from './loading/loading.component';
import { FooterAppComponent } from './footer-app/footer-app.component';
import { PlanesSegurosComponent } from './planes-seguros/planes-seguros.component';
import { CardsPlanesComponent } from './cards-planes/cards-planes.component';
import { TimeLineBootstrapComponent } from './time-line-bootstrap/time-line-bootstrap.component';
import { InfoMensajeComponent } from './info-mensaje/info-mensaje.component';
import { TextoPrincipalPlanesComponent } from './texto-principal-planes/texto-principal-planes.component';
import { BannerAppComponent } from './banner-app/banner-app.component';
import { ResumenCompraComponent } from './resumen-compra/resumen-compra.component';
import { DuracionContratoComponent } from './duracion-contrato/duracion-contrato.component';
import { NgbAlertModule, NgbDateParserFormatter, NgbDatepickerModule, NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessagesComponent } from './messages/messages.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { ArmarPlanComponent } from './armar-plan/armar-plan.component';
import { MomentDateFormatter } from '../models/momentdate';
import { DateDirective } from '../models/date.directive';
import { HttpClientModule } from '@angular/common/http';
import { DatosPropietarioComponent } from './datos-propietario/datos-propietario.component';
import { ConexionInterrumpidaComponent } from './FinFlujo/conexion-interrumpida/conexion-interrumpida.component';
import { FinFlujoComponent } from './FinFlujo/fin-flujo/fin-flujo.component';
import { CotizacionPausaComponent } from './FinFlujo/cotizacion-pausa/cotizacion-pausa.component';
import { TiempoInactivoComponent } from './FinFlujo/tiempo-inactivo/tiempo-inactivo.component';
import { ErrorComponent } from './FinFlujo/error/error.component';
import { FinFlujoPEPComponent } from './FinFlujo/fin-flujoPEP/fin-flujoPEP.component';
import { FinFlujoPEmbComponent } from './FinFlujo/fin-flujoPEmb/fin-flujoPEmb.component';
import { ScoreFinancieroComponent } from './FinFlujo/score-financiero/score-financiero.component';
import { NoSarlaftComponent } from './FinFlujo/no-sarlaft/no-sarlaft.component';
import { CumuloComponent } from './FinFlujo/cumulo/cumulo.component';
import { InfoInmuebleComponent } from './info-inmueble/info-inmueble.component';
import { CardInmuebleComponent } from './card-inmueble/card-inmueble.component';
import { MensajePropietarioComponent } from './mensaje-propietario/mensaje-propietario.component';
import { DatosInquilinoComponent } from './datos-inquilino/datos-inquilino.component';
import { PagoExitosoComponent } from './pago-exitoso/pago-exitoso.component';
import { ProcesarPagoComponent } from './procesar-pago/procesar-pago.component';
import { PagoRechazadoComponent } from './pago-rechazado/pago-rechazado.component';
import { ResumenProcesoComponent } from './inquilino/resumen-proceso/resumen-proceso.component';
import { VerificacionNcelularComponent } from './inquilino/verificacion-ncelular/verificacion-ncelular.component';
import { ValidacionCodigoInquilinoComponent } from './inquilino/validacion-codigo-inquilino/validacion-codigo-inquilino.component';
import { PreguntasSeguridadComponent } from './inquilino/preguntas-seguridad/preguntas-seguridad.component';
import { FirmaContratoInquilinoComponent } from './inquilino/firma-contrato-inquilino/firma-contrato-inquilino.component';
import { DatosInquilinoInicialComponent } from './datos-inquilino-inicial/datos-inquilino-inicial.component';
import { NoValidacionIdentidadComponent } from './FinFlujo/no-validacion-identidad/no-validacion-identidad.component';
import { CotizacionPausa2Component } from './FinFlujo/cotizacion-pausa2/cotizacion-pausa2.component';
import { CotizacionPausa3Component } from './FinFlujo/cotizacion-pausa3/cotizacion-pausa3.component';
import { PuertaEntradaComponent } from './PruetaEntrada/puerta-entrada/puerta-entrada.component';
import { HomenoComponent } from './home-no-inq/homeno/homeno.component';
import { InfoArriendoNoComponent } from './info-arriendo-no-inq/info-arriendo-no/info-arriendo-no.component';
import { LoadingNoComponent } from './loading-no-inq/loading-no/loading-no.component';
import { PlanesnoComponent } from './planes-no-inq/planesno/planesno.component';
import { CardPlanesNoComponent } from './card-planes-no-inq/card-planes-no/card-planes-no.component';
import { FinFlujoNoComponent } from './FinFlujo/fin-flujo-no-inq/fin-flujo-no/fin-flujo-no.component';
import { ArmaPlanNoComponent } from './arma-plan-no-inq/arma-plan-no/arma-plan-no.component';
import { InfoMensajeNoComponent } from './info-mensaje-no-inq/info-mensaje-no/info-mensaje-no.component';
import { DiscountbannerComponent } from './discountbanner/discountbanner.component';
import { CurrencyPipePipe } from '../pipes/currency-pipe.pipe';
import { CurrencyFormatterDirective } from '../directives/currency-directive.directive';
import { PreventScrollDirective } from '../directives/prevent-scroll.directive';
import { ArmaTuPlanAMedidaComponent } from './arma-tu-plan-a-medida/arma-tu-plan-a-medida.component';
import { DetailResumeSigningGeneralComponent } from './general/detail-resume-signing-general/detail-resume-signing-general.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    PreventScrollDirective,
    CurrencyFormatterDirective,
    CurrencyPipePipe,
    InfoArrendamientosComponent,
    TimeLineComponent,
    LoadingComponent,
    FooterAppComponent,
    PlanesSegurosComponent,
    CardsPlanesComponent,
    TimeLineBootstrapComponent,
    InfoMensajeComponent,
    TextoPrincipalPlanesComponent,
    BannerAppComponent,
    ResumenCompraComponent,
    DuracionContratoComponent,
    MessagesComponent,
    FeedbackComponent,
    ArmarPlanComponent,
    DateDirective,
    DatosPropietarioComponent,
    ConexionInterrumpidaComponent,
    FinFlujoComponent,
    CotizacionPausaComponent,
    TiempoInactivoComponent,
    ErrorComponent,
    FinFlujoPEPComponent,
    FinFlujoPEmbComponent,
    ScoreFinancieroComponent,
    NoSarlaftComponent,
    CumuloComponent,
    InfoInmuebleComponent,
    CardInmuebleComponent,
    MensajePropietarioComponent,
    DatosInquilinoComponent,
    PagoExitosoComponent,
    ProcesarPagoComponent,
    PagoRechazadoComponent,
    ResumenProcesoComponent,
    VerificacionNcelularComponent,
    ValidacionCodigoInquilinoComponent,
    PreguntasSeguridadComponent,
    FirmaContratoInquilinoComponent,
    DatosInquilinoInicialComponent,
    NoValidacionIdentidadComponent,
    CotizacionPausa2Component,
    CotizacionPausa3Component,
    PuertaEntradaComponent,
    HomenoComponent,
    InfoArriendoNoComponent,
    LoadingNoComponent,
    PlanesnoComponent,
    CardPlanesNoComponent,
    FinFlujoNoComponent,
    CardPlanesNoComponent,
    ArmaPlanNoComponent,
    InfoMensajeNoComponent,
    DiscountbannerComponent,
    ArmaTuPlanAMedidaComponent,
    DetailResumeSigningGeneralComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    HttpClientModule,
    NgbPaginationModule,
    NgbAlertModule
  ],
  exports: [
    PreventScrollDirective,
    DiscountbannerComponent,
    InfoArrendamientosComponent,
    TimeLineComponent,
    LoadingComponent,
    FooterAppComponent,
    PlanesSegurosComponent,
    CardsPlanesComponent,
    TimeLineBootstrapComponent,
    InfoMensajeComponent,
    BannerAppComponent,
    ResumenCompraComponent,
    DuracionContratoComponent,
    MessagesComponent,
    FeedbackComponent,
    ArmarPlanComponent,
    DatosPropietarioComponent,
    ConexionInterrumpidaComponent,
    FinFlujoComponent,
    CotizacionPausaComponent,
    TiempoInactivoComponent,
    ErrorComponent,
    FinFlujoPEPComponent,
    FinFlujoPEmbComponent,
    ScoreFinancieroComponent,
    NoSarlaftComponent,
    CumuloComponent,
    InfoInmuebleComponent,
    CardInmuebleComponent,
    MensajePropietarioComponent,
    DatosInquilinoComponent,
    PagoExitosoComponent,
    ProcesarPagoComponent,
    PagoRechazadoComponent,
    ResumenProcesoComponent,
    VerificacionNcelularComponent,
    ValidacionCodigoInquilinoComponent,
    PreguntasSeguridadComponent,
    FirmaContratoInquilinoComponent,
    DatosInquilinoInicialComponent,
    NoValidacionIdentidadComponent,
    CotizacionPausa2Component,
    CotizacionPausa3Component,
    PuertaEntradaComponent,
    HomenoComponent,
    InfoArriendoNoComponent,
    LoadingNoComponent,
    PlanesnoComponent,
    CardPlanesNoComponent,
    FinFlujoNoComponent,
    CardPlanesNoComponent,
    ArmaPlanNoComponent,
    InfoMensajeNoComponent,
    ArmaTuPlanAMedidaComponent,
    DetailResumeSigningGeneralComponent
  ],
  bootstrap: [DuracionContratoComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: MomentDateFormatter }]
})
export class ComponentsModule { }
